/**
 * The site-wide schema.org nodes the marketing sub-pages reference by `@id`.
 *
 * Both /pricing and /faq point `isPartOf` at `#website` and `publisher` at
 * `#organization`. Defined once here so the two pages can never emit
 * disagreeing bodies for the same `@id` — a consumer that merges the graph by
 * `@id` would otherwise see whichever page it crawled last. `#organization`
 * mirrors the canonical Organization node the landing emits in full
 * (`src/routes/_home/index.tsx`); the sub-pages carry the identifying subset,
 * not `sameAs`, which belongs with the node that declares the profiles.
 */

export const SITE_URL = "https://goodsender.com/";

export const WEBSITE_NODE = {
  "@type": "WebSite",
  "@id": "https://goodsender.com/#website",
  url: SITE_URL,
  name: "GoodSender",
} as const;

export const PUBLISHER_NODE = {
  "@type": "Organization",
  "@id": "https://goodsender.com/#organization",
  name: "GoodSender",
  url: SITE_URL,
  logo: "https://goodsender.com/logo512.png",
  parentOrganization: {
    "@type": "Organization",
    name: "Joy Labs Ventures",
    url: "https://joylabs.com",
  },
} as const;

/**
 * A JSON-LD body, serialized for a `<script type="application/ld+json">`.
 *
 * `JSON.stringify` escapes nothing HTML-significant: a `</script>` or `<!--`
 * anywhere in the graph ends the block early and the remainder of the JSON
 * lands in the document as markup. Every input is a compile-time constant
 * today, but the bodies now flow from `content/marketing`, so one FAQ answer
 * quoting a tag would do it. `<` is an ordinary JSON string escape, so
 * the parsed value is byte-for-byte the same object (#792 review).
 */
export function jsonLdScript(value: unknown): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}
